import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "services/api";
import { supabase } from "supabaseClient";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiInput from "components/VuiInput";
import VuiButton from "components/VuiButton";
import GradientBorder from "examples/GradientBorder";

// Vision UI Dashboard assets
import radialGradient from "assets/theme/functions/radialGradient";
import palette from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgSignIn from "assets/images/signInImage.png";

// Material-UI components for alerts
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: process.env.REACT_APP_REDIRECT_URL_AFTER_PASSWORD_RESET,
      });

      if (error) {
        throw error;
      }
      try {
        await api.post('/webhooks/password-reset/request', { email });
      } catch (logError) {
        console.warn('Falha ao registrar o pedido de reset de senha:', logError);
      }
      setSuccess("Se o e-mail estiver cadastrado, você receberá um link para redefinir sua senha.");
    } catch (err) {
      console.error("Erro ao solicitar redefinição de senha:", err);
      setError("Ocorreu um erro. Por favor, tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <CoverLayout
      title="Esqueceu sua senha?"
      color="white"
      description="Sem problemas! Digite seu e-mail e enviaremos um link para você"
      premotto=""
      mottoLine1="SEU LANÇAMENTO PROTEGIDO:"
      mottoLine2="SAFERDOCK"
      image={bgSignIn}
    >
      <VuiBox component="form" role="form" onSubmit={handleSubmit}>
        <VuiBox mb={2}>
          <VuiBox mb={1} ml={0.5}>
            <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
              Email
            </VuiTypography>
          </VuiBox>
          <GradientBorder
            minWidth="100%"
            padding="1px"
            borderRadius={borders.borderRadius.lg}
            backgroundImage={radialGradient(
              palette.gradients.borderLight.main,
              palette.gradients.borderLight.state,
              palette.gradients.borderLight.angle
            )}
          >
            <VuiInput type="email" placeholder="Seu e-mail..." fontWeight="500" onChange={(e) => setEmail(e.target.value)} required />
          </GradientBorder>
        </VuiBox>

        {success && (
          <VuiBox mb={2}>
            <Alert severity="success">{success}</Alert>
          </VuiBox>
        )}
        {error && (
          <VuiBox mb={2}>
            <Alert severity="error">{error}</Alert>
          </VuiBox>
        )}

        <VuiBox mt={4} mb={1}>
          <VuiButton type="submit" color="info" fullWidth disabled={loading}>
            {loading ? <CircularProgress size={24} color="inherit" /> : "ENVIAR LINK"}
          </VuiButton>
        </VuiBox>
        <VuiBox mt={3} textAlign="center">
          <VuiTypography variant="button" color="text" fontWeight="regular">
            Lembrou sua senha?{" "}
            <VuiTypography
              component={Link}
              to="/authentication/sign-in"
              variant="button"
              color="white"
              fontWeight="medium"
            >
              Entrar
            </VuiTypography>
          </VuiTypography>
        </VuiBox>
      </VuiBox>
    </CoverLayout>
  );
}

export default ForgotPassword;
